// ===============================|| Blank Layout ||=============================== //
<template>
  <v-app>
    <NuxtPage  />
  </v-app>
</template>


